import { Injectable } from '@angular/core';
import { CanActivate } from "@angular/router";
import { Utility } from "./Services/utility";

@Injectable()
export class ActivateRoutesGuard implements CanActivate {
    //used to validate route when admin login on behalf of candidate
    constructor(private utility: Utility) { }

    canActivate() {
      return this.utility.getUserRole() == "CANDIDATE" || this.utility.isAdminAsCandidate();
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/activate-routes-guard.ts